import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=6387def9&"
import script from "./OnDemand.vue?vue&type=script&lang=js&"
export * from "./OnDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6387def9')) {
      api.createRecord('6387def9', component.options)
    } else {
      api.reload('6387def9', component.options)
    }
    module.hot.accept("./OnDemand.vue?vue&type=template&id=6387def9&", function () {
      api.rerender('6387def9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/OnDemand.vue"
export default component.exports